import { User } from "models/User";
import UserProfile from "models/UserProfile";

function getUserBusinessType(userProfile?: UserProfile): string {
  const policy = userProfile?.policy;

  if (!policy) {
    return "";
  } else {
    if (!!policy.membership) {
      return "b2c";
    } else if (!!policy.trip) {
      return policy.trip.partnerSlug;
    } else {
      return "";
    }
  }
}

interface IUserEventData {
  hashed_email_id: string;
}

function getUserEventProps(
  user?: User | null,
  userProfile?: UserProfile | null
): IUserEventData | Record<string, never> {
  if (user && userProfile) {
    return {
      hashed_email_id: user.hashedEmail,
    };
  } else {
    return {};
  }
}

export { getUserBusinessType, getUserEventProps };
